// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-f6af4a86] {\n  background-color: #2F64A3;\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
